import { registerService } from './lib';

export type MarketDataPage = 'buy' | 'price';

declare module './lib' {
  interface ServiceRegistry {
    'market-data': ServiceEndpoints<{
      'get:coin/{slug}/': {
        params: {
          slug: string;
          type?: 'faq';
        };
        response: {
          slug: string;
          contents: {
            type: 'faq' | 'about' | 'description' | 'html' | 'text';
            data_base64: string;
          }[];
        };
      };
      'get:v2/coin/{slug}/': {
        params: {
          slug: string;
          page: MarketDataPage;
        };
        response: {
          type:
            | 'html'
            | 'text'
            | 'price'
            | 'chart'
            | 'vote'
            | 'time_machine'
            | 'tabs'
            | 'market_data';
          title?: string;
          data_base64?: string;
          show_in_tab?: boolean;
        }[];
      };
    }>;
  }
}

registerService('market-data', '/proxy/market-data');
